<template lang="pug">
  div.map-relation-update
    div.tooltip--map.modal--map
      div.header
        h1.title {{id ? 'Редактирование связи' : 'Создание связи'}}
        span(@click="close($event)").close.close--small.close--tooltip
      e-form(
        :formValidator="formValidator"
        formClass="body"
        :enablePerfectScrollbar="false"
      )
        div.col.start
          e-form-group(
            v-if="currentStartPoint === 'object'"
            placeholder="Введите название объекта..."
            name="startTkoObjectIdName"
            realName="start_tko_object_id"
            inputType="suggestion"
            label="Связь от объекта:"
            :model="fields"
            :required="true"
            :options="threadsTkoObjectsWithRealId"
            tabView="tab1"
          )
          e-form-group(
            v-else-if="currentStartPoint === 'garbageSource'"
            placeholder="Введите название или адрес отходообразователя..."
            name="garbageSourceIdName"
            realName="garbage_source_id"
            inputType="suggestion"
            label="Связь от отходообразователя:"
            :model="fields"
            :required="true"
            :options="garbageSources"
            tabView="tab1"
          )
          e-form-group(
            v-else
            placeholder="Введите название города..."
            name="localityIdName"
            realName="locality_id"
            inputType="suggestion"
            label="Связь от города:"
            :model="fields"
            :required="true"
            :options="settlements"
            tabView="tab1"
          )

        div.col.swap
            div(@click="swap()").col-block
              div.arrows-from-to
                //img(src="~img/icons/arrows-from-to.svg")
        div.col.end
            e-form-group(
              placeholder="Введите название объекта..."
              name="tkoObjectIdName"
              realName="tko_object_id"
              inputType="suggestion"
              label="Связь до:"
              :model="fields"
              :required="true"
              :options="threadsTkoObjectsWithRealId"
              tabView="tab1"
            )

      div.body.body-table
        div.table-choose-panel
          div.toolbar-table
            div.select
            div.toolbar.toolbar--modal
              div.line
                div.actions-panel
                  e-button-add(@click="addNewRow()")
                  // button(@click="addNewRow()").actions-panel__button.btn-add.green

        e-table-editable(
          :tableInOnlineMode="null"
          :enableOnAdd="enableOnAdd"
          :attributes="attributes"
          ref="editTable"
          :afterFetchData="afterFetchData"
          :dataUrl="dataUrl"
          :postUrl="postUrl"
          :patchUrl="patchUrl"
          :deleteUrl="deleteUrl"
          :tableHeight="'200'"
          :tableHeightRight="'200'"
          :fewRowsCount="2"
          :scrollBarUpdateStreamName="updateScrollStreamName"
          @afterFetchData="tableEditableAfterFetchData"
        )

      div.footer
        div.actions-filter-panel.actions-filter-panel--right
          div
            button(@click="close($event)").actions-filter-panel__button.standart.standart-noborder Отмена
            button(
              v-if="userCanWrite" @click="saveForm($event)" :disabled="loading"
            ).actions-filter-panel__button.standart {{saving ? 'Сохранение...' : 'Сохранить'}}
</template>

<script>
  import mapRelationForm from '../mixins/map-relation-form.js'
  import {map as mapEndpoints } from '../../../api/api-endpoints.js'
  import year from '../../../utils/year.js'
  import baseMapObjectMixin from '../mixins/base-map-object-mixin.js'

  const DefaultFields = () => {
    return {
      locality_id: '',
      localityIdName: '',
      tko_object_id: '',
      tkoObjectIdName: '',
      start_tko_object_id: '',
      startTkoObjectIdName: '',
      garbage_source_id: '',
      garbageSourceIdName: ''
    }
  }
  export default {
    mixins: [mapRelationForm, baseMapObjectMixin],
    name: 'map-relation-update',
    data () {
      return {
        fields: new DefaultFields()
      }
    },
    methods: {
      getMapTkoObjectsEndpoint () {
        return mapEndpoints.objectForThreads()
      },
      getThreadEndpoint (route) {
        if (!route.query.year) {
          route.query.year = year.getCurrentYear()
        }
        return mapEndpoints.threadsByYear(route)
      },
      getItemEndpoint (id) {
        return mapEndpoints.thread(id)
      },
      getUpdateOrCreateUrl (id, year) {
        return mapEndpoints.threadUpdateOrCreate(id, year)
      },
      getSettlementEndpoint (route) {
        return mapEndpoints.settlements(route)
      },
      getGarbageSourceEndpoint (route) {
        return mapEndpoints.garbageSources(route)
      },
      injectConf (options) {
        let {model, closeCallback} = options
        if (model && model.end && model.end.thread_id) {
          this.id = model.end.thread_id
          if(model.end.start_tko_object_id){
            this.currentStartPoint = 'object'
          } else {
            this.currentStartPoint = 'settlement'
          }
          this.fetchData()
          if(model.end.garbage_source_id){
            this.currentStartPoint = 'garbageSource'
          }
        } else if (model && model.type) {
          this.id = null
          this.loading = false
          this.resetFields(new DefaultFields())

          if (model.type === 'settlement') {
            if (this.threadsSettlements) {
              for (let i = 0; i < this.threadsSettlements.length; i++) {
                if (this.threadsSettlements[i].locality_id === model.id) {
                  this.fields.locality_id = this.threadsSettlements[i].locality_id
                  break
                }
              }
            }
            if (!this.fields.locality_id) {
              this.fields.locality_id = model.id
            }
          } else if (model.type === 'tko') {
            //this.isObjectToObject = model.start_tko_object_id
            this.fields.tko_object_id = (model.tko_object_id || model.id)
          }
        } else {
          this.id = null
          this.resetFields(new DefaultFields())
        }
        this.closeCallback = closeCallback
        this.registerVueInMap()
      },
      close ($event) {
        this.closeCallback($event)
      }
    }
  }
</script>
